import { send } from "xstate"

export default {
  placeOrderReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.PLACE_ORDER_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  unUsedCouponReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.UNUSED_COUPON,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  receiveTaskPresentErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.RECEIVE_TASK_PRESENT_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  queryMultiCouponSuccessReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.QUERY_BATCH_COUPON_SUCCESS,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  queryMultiCouponErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.QUERY_BATCH_COUPON_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  getAllTaskPresentErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.BATCH_RECEIVE_TASK_PRESENT_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  get6BatchCouponErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.QUERY_BATCH_DRAW_COUPON_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  loginPromptReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.LOGIN_PROMPT,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  loginErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.LOGIN_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  switchMapReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK.SWITCH_MAP,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  freeTaskTodoReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.FREE_TASK_TODO
  })),
  freeTaskDoneReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.FREE_TASK_DONE
  })),
  getFreeTaskReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.GET_FREE_TASK
  })),
  goBattleReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.GO_BATTLE
  })),
  receivedTaskGoLotteryReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.RECEIVE_TASK_GO_LOTTERY
  })),
  checkBattleErrorReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.CHECK_BATTLE_ERROR
  })),
  joinFreeTaskErrorReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.JOIN_FREE_TASK_ERROR
  })),
  getPrizeListSuccess: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.GET_PRIZE_LIST_SUCCESS,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  getPrizeListFailure: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.GET_PRIZE_LIST_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  retryPrizeList: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK.RETRY_PRIZE_LIST,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  nowLivesClick: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK.nowClick,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  payErrorReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.PAY_ERROR,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  confirmPayReport: send((context, event) => ({
    type: "REPORT",
    iformat: context.report.CLICK.CONFIRM_PAY,
    resultInfo: Object.assign(context, { event: event.data })
  })),
  selectBuyProductReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK[`SELECT_BUY_PRODUCT_${context.purchaseInfo.price}`],
    resultInfo: context
  })),
  selectFightAndPayReport: send(context => ({
    type: "REPORT",
    iformat: context.report.PAGEVIEW.SELECT_TASK_OR_PAY
  })),
  selectGoBattleReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.SELECT_GOBATTLE
  })),
  selectBattledReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.SELECT_BATTLED
  })),
  selectLotteryReport: send(context => ({
    type: "REPORT",
    iformat: context.report.CLICK.SELECT_GOLOTTERY
  }))
}
